import BasePerimeter from './base';

export default new BasePerimeter({
    purpose: 'orders',
    govern: {
        'can viewNotes': function () {
            return (this.isSuperAdmin() || this.isAdmin())
        },
        'can viewClients': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin())
        },
        'can viewCampaigns': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin())
        },
        'can viewPrices': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin())
        },
        'can exportCsv': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin())
        },
        'can updateInvoice': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin() || this.isAgencyAdmin())
        },
        'can viewFoc': function () {
            return (this.isSuperAdmin() || this.isAdmin())
        },
    }
});
